import { useState, useRef, useCallback, useEffect, useContext } from 'react'
import { useSelector } from 'react-redux'

import { AnimatedWindowCallbackContext } from 'context/window/AnimatedWindowProvider'

import { delay } from 'utils/utils'

import ProductPolicy from 'components/presenters/commerce/product/ProductPolicy'
import ProductVendorInfo from 'components/presenters/commerce/product/ProductVendorInfo'

const useProductDetail = () => {
  const { productInfo, shippingInfo, productPolicyInfo, vendorInfo, reviewUrlInfo } = useSelector(
    (state) => state.productDetailInfo,
  )
  const { openWindow } = useContext(AnimatedWindowCallbackContext)

  const scrollRef = useRef(null)
  const isInitScroll = useRef(true)
  const isTabScroll = useRef(false)

  const [currTab, setCurrTab] = useState('product_info')
  const [scrollDest, setScrollDest] = useState(null)

  useEffect(() => {
    if (![null, undefined].includes(scrollDest)) {
      const newDest = scrollDest
      moveToId(newDest)
    }
  }, [scrollDest])

  const moveToId = async (newDest) => {
    const element = document.getElementById(newDest)
    const currScrollPosition = scrollRef.current.scrollTop
    const width = scrollRef.current.offsetWidth
    const headerOffset = width * (148 / 375)
    const elementPosition = element.getBoundingClientRect().top
    const offsetPosition = elementPosition + currScrollPosition - headerOffset

    scrollRef.current.scrollTo({
      top: offsetPosition,
    })
    await delay(1000)
    isTabScroll.current = false
    setScrollDest(null)
  }

  const handleScroll = useCallback(() => {
    isInitScroll.current = false
  }, [isInitScroll])

  const handleChangeTab = useCallback((tabVal) => {
    isTabScroll.current = true
    setScrollDest(tabVal)
  }, [])

  const changeCurrTabByScroll = useCallback((currTab) => {
    if (isTabScroll.current === false && isInitScroll.current === false) {
      setCurrTab(currTab)
    }
  }, [])

  const handleClickPolicyBtn = () => {
    openWindow({
      Component: (
        <ProductPolicy
          shippingName={shippingInfo.name}
          price={shippingInfo.price}
          refundPrice={shippingInfo.refund_price}
          shippingPolicy={productPolicyInfo.shipping_policy}
          refundPolicy={productPolicyInfo.refund_policy}
        />
      ),
      headerProps: { title: '배송/교환/반품 정책' },
    })
  }

  const handleClickVendorBtn = () => {
    openWindow({
      Component: <ProductVendorInfo vendorInfo={vendorInfo} />,
      headerProps: { title: '판매자 정보' },
    })
  }

  return {
    productInfo,
    shippingInfo,
    vendorInfo,
    reviewUrlInfo,
    scrollRef,
    currTab,
    handleScroll,
    handleChangeTab,
    changeCurrTabByScroll,
    handleClickPolicyBtn,
    handleClickVendorBtn,
  }
}

export default useProductDetail
